export class Environment {
  static getBaseUrl(): string {
    if (process.env.NODE_ENV === "development") {
      return "http://localhost:8080";
    } else {
      return "https://storage.googleapis.com/ny-gaume.appspot.com";
      // return "http://localhost:8081";
    }
  }
}
